import $ from 'jquery'
import constants from '@/util/constants'

window.$ = window.jQuery = $

export default (rotaDestino, rotaOrigem) => {
  setTimeout(() => {
    if (rotaDestino.name !== constants.nomeRotaLogin) {
      window.$('body').removeClass('sidebar-open')
    }
  }, 700)
}
